/*
* 金额单位元  2位小数点
* */
export function amountConversion2(money) {
  let value = Math.round(parseFloat(money) * 100) / 100
  const moneyStr = money.toString().split('.')
  if (moneyStr.length === 1) {
    value = value.toString() + '.00'
    return value
  }
  if (moneyStr[1].length > 1) {
    if (moneyStr[1].length < 2) {
      value = value.toString() + '0'
      return value
    }
    const str = moneyStr[1].split('')
    value = moneyStr[0] + '.' + str[0] + str[1]
  }
  return value
}

/*
* 金额单位万元  6位小数点
* */
export function amountConversion6(money) {
  let value = Math.round(parseFloat(money) * 1000000) / 1000000
  const moneyStr = money.toString().split('.')
  if (moneyStr.length === 1) {
    value = value.toString() + '.000000'
    return value
  }
  if (moneyStr[1].length > 1) {
    if (moneyStr[1].length < 6) {
      for (let i = 0; i < (6 - moneyStr[1].length); i++) {
        value = value.toString() + '0'
      }

      return value
    }
    const str = moneyStr[1].split('')
    value = moneyStr[0] + '.' + str[0] + str[1] + str[2] + str[3] + str[4] + str[5]
  }
  return value
}

/**
 * @description  四舍五入，保留位数为roundDigit
 * @param numberRound 原来的数字，支持number或string类型
 * @param roundDigit 保留的小数位
 * @param forced 是否强制保留后面的“0”。默认为false：即不会出现10.000。会返回10    如果改为true则强制保留0，出现10.000
 * @return {number}
 */
function roundFun(numberRound, roundDigit, forced = false) {
  numberRound = parseFloat(numberRound)
  let negativeFlag = false
  if (numberRound < 0) {
    numberRound = -numberRound
    negativeFlag = true
  }
  let tempNumber = parseInt((numberRound * Math.pow(10, roundDigit) + 0.5)) / Math.pow(10, roundDigit)
  if (negativeFlag) {
    tempNumber = - tempNumber
  }
  const xsd = tempNumber.toString().split('.')
  if (xsd.length === 1) {
    let dian = '.'
    for (let i = 0; i < roundDigit; i++) {
      dian += '0'
    }
    tempNumber = tempNumber.toString() + dian
  }
  if (xsd.length > 1) {
    if (xsd[1].length < roundDigit) {
      let dian = ''
      for (let i = 0; i < roundDigit - xsd[1].length; i++) {
        dian += '0'
      }
      tempNumber = tempNumber.toString() + dian
    }
  }
  if (forced) {
    return tempNumber
  } else {
    return parseFloat(tempNumber)
  }
}


/**
 *生成32位uuid
 */
export function uuid() {
  const s = []
  const hexDigits = '0123456789abcdefghijklmnABCDEFGHIJKLMN'
  for (let i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = '-'

  return s.join('')
}

/*
 * 金额中文大写，如 贰拾贰元贰角壹分
 */
export function toCapitalChinese(money) {
  var islessthan0 = money < 0;
  if (islessthan0) {
    money = Math.abs(money);
  }

  if (money == 0) {
    return '零元整'
  }

  // 汉字的数字
  var cnNums = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
  // 基本单位
  var cnIntRadice = ['', '拾', '佰', '仟']
  // 对应整数部分扩展单位
  var cnIntUnits = ['', '万', '亿', '兆']
  // 对应小数部分单位
  var cnDecUnits = ['角', '分','厘', '毫' ]
  // 整数金额时后面跟的字符
  var cnInteger = '整'
  // 整型完以后的单位
  var cnIntLast = '元'
  // 最大处理的数字
  var maxNum = 999999999999999.9999
  // 金额整数部分
  var integerNum
  // 金额小数部分
  var decimalNum
  // 输出的中文金额字符串
  var chineseStr = ''
  // 分离金额后用的数组，预定义
  var parts
  // 传入的参数为空情况
  if (money == '') {
    return ''
  }
  money = parseFloat(money)
  if (money >= maxNum) {
    return ''
  }
  // 传入的参数为0情况
  if (money == 0) {
    chineseStr = cnNums[0] + cnIntLast + cnInteger
    return chineseStr
  }
  // 转为字符串
  money = money.toString()
  // indexOf 检测某字符在字符串中首次出现的位置 返回索引值（从0 开始） -1 代表无
  if (money.indexOf('.') == -1) {
    integerNum = money
    decimalNum = ''
  } else {
    parts = money.split('.')
    integerNum = parts[0]
    decimalNum = parts[1].substr(0, 4)
  }
  // 转换整数部分
  if (parseInt(integerNum, 10) > 0) {
    let zeroCount = 0
    const IntLen = integerNum.length
    for (let i = 0; i < IntLen; i++) {
      const n = integerNum.substr(i, 1)
      const p = IntLen - i - 1
      const q = p / 4
      const m = p % 4
      if (n == '0') {
        zeroCount++
      } else {
        if (zeroCount > 0) {
          chineseStr += cnNums[0]
        }
        zeroCount = 0
        chineseStr += cnNums[parseInt(n)] + cnIntRadice[m]
      }
      if (m == 0 && zeroCount < 4) {
        chineseStr += cnIntUnits[q]
      }
    }
    // 最后+ 元
    chineseStr += cnIntLast
  }
  // 转换小数部分
  if (decimalNum != '') {
    const decLen = decimalNum.length
    for (let i = 0; i < decLen; i++) {
      const n = decimalNum.substr(i, 1)
      if (n != '0') {
        chineseStr += cnNums[Number(n)] + cnDecUnits[i]
      }
    }
  }
  if (chineseStr == '') {
    chineseStr += cnNums[0] + cnIntLast + cnInteger
  } else if (decimalNum == '') {
    chineseStr += cnInteger
  }

  if (islessthan0) {
    return `负${chineseStr}`
  }
  return chineseStr
}

// 转为千分位
export function toUS(ori, force2 = false) {
  if (force2) {
    return ori.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }
  return ori.toLocaleString('en-US', {
    maximumFractionDigits: 2
  });
}


export default {
  amountConversion2,
  amountConversion6,
  roundFun,
  uuid,
  toCapitalChinese
}
